import { render, staticRenderFns } from "./FileList.vue?vue&type=template&id=4c135cbd&"
import script from "./FileList.vue?vue&type=script&lang=js&"
export * from "./FileList.vue?vue&type=script&lang=js&"
import style0 from "./FileList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports